<template>
  <div class="z-index-2 welness-container">
    <div class="row" style="padding-left: 2rem;padding-bottom: 0.75rem;">
      <div style="width: 55%;" class="text-sm text-uppercase text-primary">
         MONTH ON MONTH TREND
      </div>
      <div style="width: 45%;">
        <SectionDropdown style="float: right;margin-right: 3rem;"
          id="ddSectionFilter"
          :selected="selectedSection"
          @selected-section-id="
          (selectedValue) => (selectedSection = selectedValue)
          "
        />
      </div>
    </div>
    
    <div class="row" style="padding-left: 2rem;">
      <div class="col-12" style="width: 65%;padding-right: 0;">
        <span class="header">Wellness Scores</span>
        <span style="color: #bce1da">Evaluates sleep, RHR, HRV and workouts</span>
      </div>
      <div class="col-12" style="width: 35%;padding-left: 0;padding-right: 1rem;">
        <div>
          <span v-if="previousScore > 0" class="previous-score">{{previousScore}}% 
            <img src="/img/icons/ic_arrow_right.svg" class="wellness-icon ms-2" />
          </span>
          <span style="padding-left: 1rem;" class="current-score">{{currentScore}}%</span>
        </div>
        <div>
          <div v-if="wellnessVariance > 0" class="trend-icon"
              style="background-color: #314e32;">
            <img src="/img/icons/ic_trending_up.svg" class="wellness-icon ms-2" />
            <span class="positive-insight"> + {{this.wellnessVariance}}% vs last month</span>
          </div>
          <div v-if="wellnessVariance < 0" class="trend-icon" style="background-color: #563129;">
            <img src="/img/icons/ic_trending_down.svg" class="wellness-icon ms-2" />
            <span class="negative-insight">  {{this.wellnessVariance}}% vs last month</span>
          </div>
          <div v-if="wellnessVariance == 0" class="trend-icon"
              style="background-color: #314e32;">
            <img src="/img/icons/ic_arrow_right.svg" class="wellness-icon ms-2" />
            <span class="positive-insight"> No Change</span>
          </div>
          <span>{{ this.wellnessInsight }}</span>
        </div>
      </div>
    </div>
    <div class="p-3" style="padding-top: 0 !important;padding-bottom: 0 !important;">
      <div>
        <canvas :id="id" class="welness-chart" :height="height"></canvas>
        <div v-if="tooltip.visible" class="custom-tooltip" 
            :style="{ top: tooltip.y + 'px', left: tooltip.x + 'px' }">
          <strong class="tooltip-title">{{ tooltip.title }}</strong><br>
          <span style="font-size: 1.25rem;" :style="{color: tooltip.pointColor}">{{ tooltip.score }} %</span><br>
          <span style="color: #bce1da;font-size: 0.9rem;">{{ tooltip.description }}</span><br>
          <div class="factor-container">
            <span style="width: 70%;font-size: 0.9rem;">Factors Evaluated </span>
            <span class="factor-details" :class="tooltip.factorsCount == 4 ? 'all-factors' : 'partial-factors'">
              {{ tooltip.factorsCount }} of 4</span>
            <div v-for="(factor, index) in tooltip.factorsConsidered" :key="index" style="font-size: 0.8rem;"
            :style="factor.considered == true ? 'color: #4ed052' : 'color: #B0B0B0'">
              <IconSuccess v-if="factor.considered"></IconSuccess>
              <IconCancel v-if="!factor.considered"></IconCancel>
              {{factor.factor_name}}
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import IconSuccess from "@/shared/Controls/Icons/IconSuccess.vue";
import IconCancel from "@/shared/Controls/Icons/IconCancel.vue";
import annotationPlugin from "chartjs-plugin-annotation";
import DateUtils from "@/helpers/dateUtils";
import SectionDropdown from "../../../components/SectionDropdown.vue";
import { reactive } from "vue";


Chart.register(annotationPlugin);

export default {
  name: "UserWellnessChart",
  components: {
    IconSuccess,
    IconCancel,
    SectionDropdown
  },
  props: {
    id: {
      type: String,
      default: "usr-wellness-chart",
    },
    height: {
      type: String,
      default: "16rem",
    },
    selectedDate:{
      default: 'Today'
    },
    wellnessData: {
      type: Object,
      required: true,
    },
    udid: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      period: '',
      wellnessVariance: 0,
      wellnessInsight: '',
      wellnessVarianceList: [],
      lineColors: [],
      wellnessVarianceMessages: [],
      factorsEvaluatedCount: [],
      factorsConsidered: [],
      previousScore: 0,
      currentScore: 0,
      selectedSection: -1,
      tooltip : reactive({
        visible: false,
        title: "",
        variance: 0,
        description: "",
        factorsCount: 0,
        factors: [],
        x: 0,
        y: 0,
        pointColor: '',
    })
    };
  },
  watch: {
    selectedDate() {
      this.period = DateUtils.formatPeriod(this.selectedDate);
    },
    wellnessData() {
      this.prepareWellnessDetails();
      this.addChart();
    },
    selectedSection() {
      //console.log('Selected section: '+this.selectedSection);
      this.$parent.getUserWellnessData(this.udid, this.selectedSection);
    },
  },
  mounted() {
    this.prepareWellnessDetails();
    this.addChart();
  },
  methods: {
    clearData(){
      this.wellnessVarianceList = [];
      this.lineColors = [];
      this.wellnessVarianceMessages = [];
      this.factorsEvaluatedCount = [];
      this.factorsConsidered = [];
    },
    prepareWellnessDetails(){
      this.clearData();
      this.period = DateUtils.formatPeriod(this.selectedDate);
      this.currentScore = this.wellnessData[this.wellnessData.length - 1].wellness_score;
      if(this.wellnessData.length > 1) {
        this.previousScore = this.wellnessData[this.wellnessData.length - 2].wellness_score;
        this.wellnessVariance = this.currentScore - this.previousScore;
      }
      let { description } = this.getWellnessInsight(this.wellnessData[this.wellnessData.length - 1]);
      this.wellnessInsight = description;
    },
    getTooltipInfo(pointVal) {
      return pointVal;
    },
    getWellnessInsight(wellnessDetails){
      let variance = 0;
      let description = '';
      let lineColor = '';
      if(wellnessDetails.wellness_score > wellnessDetails.top_avg) {
            lineColor = '#75fa4b';
            variance = wellnessDetails.wellness_score - wellnessDetails.top_avg;
            description = 'Outperforms most peers';
      } else if(wellnessDetails.wellness_score < wellnessDetails.bottom_avg) {
            lineColor = '#f53625';
            variance = wellnessDetails.wellness_score - wellnessDetails.bottom_avg;
            description = 'Falling behind most peers';
      } else {
            lineColor = '#25f5b6';
            let average = (wellnessDetails.lower_range+wellnessDetails.upper_range)/2
            variance = wellnessDetails.wellness_score - average;
            description = 'On par with most peers';
      }

      return {lineColor, variance, description};
    },
    addChart() {
      Chart.defaults.borderColor = '#404948'; 
      const ctx = document.getElementById(this.id).getContext("2d");
      let gradientStroke1 = ctx.createLinearGradient(0, 300, 0, 50);
      gradientStroke1.addColorStop(1, "rgba(53,150,133,0.2)");
      gradientStroke1.addColorStop(0, "transparent");

      let chartStatus = Chart.getChart(this.id);
      if (chartStatus != undefined) {
          chartStatus.destroy();
      }

      let chartLabels = [];
      let wellness_scores = [];
      this.lineColors = [];
      for(let wellnessDetails of this.wellnessData) {
          chartLabels.push(wellnessDetails.month);
          wellness_scores.push(wellnessDetails.wellness_score);
          let {lineColor, variance, description} = this.getWellnessInsight(wellnessDetails);
          this.lineColors.push(lineColor);
          this.wellnessVarianceList.push(Math.round(variance));
          this.wellnessVarianceMessages.push(description);
          this.factorsEvaluatedCount.push(wellnessDetails.factors_count);
          let sortedArray = wellnessDetails.factors_included.sort(function(a,b){return a.considered-b.considered});
          sortedArray = sortedArray.reverse()
          this.factorsConsidered.push(sortedArray);
      }

      var data = {
          labels: chartLabels,
          datasets: [{
            label: "Wellness Score",
            strokeColor: "#6db3b0",
            pointRadius: 5,
            pointBackgroundColor: this.lineColors,
            data: wellness_scores,
            borderColor:  "#359685", //line color
            pointBorderWidth: 0,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointBorderColor: "#6db3b0",
            pointHoverBackgroundColor: "#6db3b0",
            pointHoverBorderColor: "#6db3b0",
            // pointRadius: 0, // to make point unvisible
            tension: 0.4,
            borderWidth: 3,
            backgroundColor: gradientStroke1,
            fill: true,
          }]
      };

      var options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              "responsive": true,
              legend: {
                  display: false,
                  position: 'bottom',
                  fill: true,
                  labels: {
                      color: '#6db3b0',
                      fill: true,
                      boxWidth: 24,
                      boxHeight: 12,
                      padding: 40,
                  }
              },
              tooltip: {
                enabled: false, // Disable default tooltip
                external: (context) => {
                const tooltipModel = context.tooltip;
                
                if (!tooltipModel || tooltipModel.opacity === 0) {
                  this.tooltip.visible = false;
                  return;
                }

                const index = tooltipModel.dataPoints[0].dataIndex;
                this.tooltip.title = chartLabels[index];
                this.tooltip.variance = this.wellnessVarianceList[index];
                this.tooltip.description = this.wellnessVarianceMessages[index];
                this.tooltip.factorsCount = this.factorsEvaluatedCount[index]
                this.tooltip.factorsConsidered = this.factorsConsidered[index];
                this.tooltip.score = wellness_scores[index];
                this.tooltip.x = tooltipModel.caretX;
                this.tooltip.y = tooltipModel.caretY + 450;
                this.tooltip.visible = true;
                this.tooltip.pointColor = this.lineColors[index];
              }
            },
          },
          scales: {
              y: {
                  ticks: {
                      fontColor: "#95a7a3", // "rgba(0,0,0,0.5)",
                      fontStyle: "bold",
                      beginAtZero: true,
                      min: 0,
                      max: 100,
                      stepSize: 20,
                  },
              },
              x: {
                  ticks: {
                      padding: 20,
                      fontColor: "#95a7a3",//"rgba(0,0,0,0.5)",
                      fontStyle: "bold"
                  },
                  gridLines: {
                    borderDash: [8, 4],
                    color: "#348632"
                },
              }
          },
      }

      new Chart(ctx, {
        type: 'line',
        data,
        options
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.welness-container {
  background-color: rgb(40, 51, 53);
  border-radius: 0.5rem;
  padding-bottom: 0.5rem;
  padding-top: 1rem;
}
.welness-chart {
  background-color: rgb(40, 51, 53);
  height: 16rem;
  width: 100%;
 }
.period {
  font-size: 0.8rem;
  text-align: left;
  color: #359685;
 }
 .header {
  font-weight: 100 !important;
  font-size: 1.2rem;
 }
 .previous-score {
  color: #bce1da;
  font-size: 1.2rem;
 }
 .current-score {
  font-size: 1.2rem;
 }
 .positive-insight {
  color: #4ed052;
  padding-left: 0.5rem;
 }
 .negative-insight {
  color: #d53232;
  padding-left: 0.5rem;
 }
 .custom-tooltip {
  //opacity: 0.75;
  position: absolute;
  background: black;
  padding: 0.7rem;
  border: 0.2rem solid black;
  border-radius: 0.5rem;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  z-index: 10;
}
.factor-container {
  border-top-style: solid; 
  border-top-color: #2c4a44;
  padding: 0.5rem;
  margin-top: 0.5rem;
}
.factor-details{
  width: 30%;
  border-radius: 0.25rem; 
  font-weight: bold;
  font-size: 1.2rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  margin-left: 1rem;
}
.all-factors {
  background-color: #125f70;
  color: #53b5b1;
  font-size: 0.9rem;
}
.partial-factors {
  background-color: #341414;
  color: #AC0000;
  font-size: 0.9rem;
}
.tooltip-title {
  font-size: 1rem;
  //color: white;
}
.wellness-icon {
  height: 0.9rem;
}
.trend-icon {
  width: 85%; 
  border-radius: 0.25rem;
}
</style>
